"use client";
import { cn } from "@/lib/utils";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";

interface PhoneNumberInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  onChange: (event: { target: { value: string } }) => void;
  className?: string;
  setSelectedCountryIsoCode?: (country: string) => void;
  error?: string;
  label?: string;
}

export default function PhoneNumberInput({
  className,
  label,
  error,
  ...props
}: PhoneNumberInputProps) {
  const handleChange = (phone: string, meta: { country: { iso2: string } }) => {
    props.onChange({ target: { value: phone } });
    if (props.setSelectedCountryIsoCode && meta.country.iso2) {
      props.setSelectedCountryIsoCode(meta.country.iso2.toLowerCase());
    }
  };

  return (
    <div>
      {label && (
        <label className="mb-1.5 cursor-pointer text-[15px] font-normal text-system-disabled">
          {label}
        </label>
      )}
      <div className={cn("relative w-full", className)}>
        <style jsx global>{`
          .react-international-phone-input-container {
            height: 42px !important;
            border-radius: 0.5rem !important;
            background-color: #1b1d24 !important;
            border: 1px solid #61646c66 !important;
          }
          .react-international-phone-input-container:focus-within {
            border-color: #2255f9 !important;
          }
          .react-international-phone-input {
            background-color: transparent !important;
            color: #fbfbfb !important;
          }
          .react-international-phone-input::placeholder {
            color: #8f9197 !important;
          }
          .react-international-phone-input:focus {
            border-color: transparent !important;
            box-shadow: none !important;
          }
          .react-international-phone-country-selector-button {
            background-color: transparent !important;
            color: #fbfbfb !important;
          }
          /* Dropdown styles */
          .react-international-phone-country-selector-dropdown {
            background-color: #1b1d24 !important;
            border: 1px solid #61646c66 !important;
            color: #fbfbfb !important;
            width: 350px !important;
            padding: 10px 0px;
            border-radius: 8px !important;
            outline: none !important;
          }
          .react-international-phone-country-selector-dropdown:hover {
            background-color: #1b1d24 !important;
          }
          .react-international-phone-country-selector-dropdown__list-item {
            padding: 8px !important;
            border-radius: 8px !important;
            margin: 4px !important;
          }
          .react-international-phone-country-selector-dropdown__list-item:hover {
            background-color: #2255f9 !important;
          }
          .react-international-phone-country-selector-dropdown__list-item-dial-code {
            color: #fbfbfb !important;
          }
          .react-international-phone-country-selector-dropdown__list-item:hover {
            background-color: #2255f9 !important;
            color: #fbfbfb !important;
          }
          .react-international-phone-country-selector-dropdown__list-item.react-international-phone-country-selector-dropdown__list-item--focused.react-international-phone-country-selector-dropdown__list-item--selected {
            background-color: #2255f9 !important;
            color: #fbfbfb !important;
          }

          .react-international-phone-country-selector-dropdown__list-item.react-international-phone-country-selector-dropdown__list-item--focused {
            background-color: #2255f9 !important;
            color: #fbfbfb !important;
          }
        `}</style>

        <PhoneInput
          value={props.value as string}
          defaultCountry="us"
          onChange={handleChange}
          className={cn("w-full", error ? "react-international-phone-input-container-error" : "")}
          inputStyle={{
            width: "100%",
            height: "42px",
            backgroundColor: "transparent",
            border: "none",
            outline: "none",
            fontSize: "16px",
            padding: "8px 16px",
          }}
          countrySelectorStyleProps={{
            buttonStyle: {
              border: "none",
              outline: "none",
              height: "42px",
              paddingLeft: "16px",
              backgroundColor: "transparent",
            },
            flagStyle: {
              width: "20px",
              height: "20px",
            },
          }}
        />
      </div>
      {error && <p className="mt-1 text-[13px] text-system-error">{error}</p>}
    </div>
  );
}
